import React from "react";
import { Zap, Clock4, BadgeCheck, Tag, MapPinned, CreditCard } from "lucide-react";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL_HREF } from "@/lib/contact";

const POINTS = [
  { icon: Zap, title: "Arrivo rapido", desc: "Tempo medio di intervento ridotto al minimo, anche nel traffico di Roma." },
  { icon: Clock4, title: "Operativi 24/7", desc: "Notte, weekend, festività: siamo sempre raggiungibili." },
  { icon: BadgeCheck, title: "Personale qualificato", desc: "Operatori esperti, mezzi a norma e attrezzati." },
  { icon: Tag, title: "Prezzi trasparenti", desc: "Preventivo chiaro al telefono, nessuna sorpresa." },
  { icon: MapPinned, title: "Copertura totale", desc: "Roma città e tutta la provincia, in qualunque zona." },
  { icon: CreditCard, title: "Contanti e carta", desc: "Pagamento flessibile, anche con carta sul posto." },
];

export default function WhyChooseUs() {
  return (
    <section id="perche-noi" data-testid="why-section" className="relative py-16 md:py-24 bg-[color:var(--brand-surface)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <p className="text-brand-orange text-sm font-bold tracking-[0.2em] uppercase">Perché sceglierci</p>
          <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-navy tracking-tight">
            Il soccorso stradale che <span className="text-brand-orange">non ti fa aspettare</span>.
          </h2>
          <p className="mt-5 text-muted-foreground text-base sm:text-lg leading-relaxed">
            Da anni assistiamo automobilisti, motociclisti e flotte aziendali a Roma. Una telefonata, una squadra,
            zero complicazioni.
          </p>
          <a
            href={PHONE_TEL_HREF}
            data-testid="why-call-button"
            className="mt-7 inline-flex items-center gap-3 rounded-2xl bg-navy text-white px-6 py-4 font-bold hover:bg-brand-orange transition-colors"
          >
            <Phone className="h-5 w-5" />
            Chiama {PHONE_DISPLAY}
          </a>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          {POINTS.map((p, i) => (
            <div
              key={p.title}
              data-testid={`why-card-${i}`}
              className="group relative rounded-2xl bg-white border border-border p-5 hover:-translate-y-1 hover:shadow-md hover:border-brand-orange/40 transition"
            >
              <div className="flex items-start gap-4">
                <div className="grid place-items-center h-11 w-11 rounded-xl bg-brand-orange/10 text-brand-orange group-hover:bg-brand-orange group-hover:text-white transition">
                  <p.icon className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-display font-extrabold text-lg text-navy">{p.title}</h3>
                  <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
